module.exports = __webpack_public_path__ + "static/img/IMG_20160101_161932.2e03d264.jpg";